export default "__VITE_ASSET__B6KOlx_t__"